import r from"./_assignValue.js";import a from"./_baseAssignValue.js";function o(o,s,e,i){var t=!e;e||(e={});for(var n=-1,f=s.length;++n<f;){var u=s[n],v=i?i(e[u],o[u],u,e,o):void 0;void 0===v&&(v=o[u]),t?a(e,u,v):r(e,u,v)}return e}export{o as default};
//# sourceMappingURL=_copyObject.js.map
